import { Component, OnInit } from '@angular/core';
import * as moment from 'moment';
import { DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';
import { MatDialog } from '@angular/material/dialog';
import { PreviewMailTemplateComponent } from '../../preview-mail-template/preview-mail-template.component';
import { PreviewBonusMailTemplateProps } from '../../preview-mail-template/preview-mail-template.types';
import { DatePipe } from '@angular/common';
import { BonusService } from '../../../bonus.service';
import { switchMap } from 'rxjs/operators';
import { MailTemplateToSave, PreviewEmailRequestProps } from '../../promotion-bonus.type';

@Component({
  selector: 'app-confirm-promotion',
  templateUrl: './confirm-promotion.component.html',
  styleUrls: ['./confirm-promotion.component.scss'],
  providers: [DatePipe]
})
export class ConfirmPromotionComponent implements OnInit {
  sendOrNot = 0;
  isSendAll = false;
  sendMailOptions = {
    sendToNewTargetAll: {
      label: 'Send emails to users new target user',
      checked: false,
      value: 'new-target-all'
    },
    tasks: [
      {
        label: 'All users',
        checked: false,
        value: 'old-target-all'
      },
      {
        label: 'Users who applied code',
        checked: false,
        value: 'old-target-applied'
      }
    ]
  };

  withTargetPersonChanged = false;
  email_new_target_promotion_content: MailTemplateToSave;
  email_old_target_promotion_content: MailTemplateToSave;
  email_change_promotion_content: MailTemplateToSave;

  tmp_email_new_target_promotion_content: MailTemplateToSave;
  tmp_email_old_target_promotion_content: MailTemplateToSave;
  tmp_email_change_promotion_content: MailTemplateToSave;

  mailLabel = {
    targetUser: 'Send emails to users under previous target user',
    dataChanges: 'Send emails to users regarding campaign data changes',
    targetAll: 'Send emails to users new target user'
  }
  preTargetUserEmail = 'Target user';
  constructor(
    private configDialog: DynamicDialogConfig,
    private refDialog: DynamicDialogRef,
    private readonly dialog: MatDialog,
    private readonly datePipe: DatePipe,
    private readonly bonusService: BonusService,
  ) {}

  result: any = [];

  ngOnInit(): void {
    const { target: data, bonus } = this.configDialog.data;
    console.log(data);
    this.preTargetUserEmail = data.email?.old_value;
    this.result = [
      {
        field: 'Campaign name',
        old: data.name?.old_value,
        new: data.name?.new_value,
        show: true
      },
      {
        field: 'Start time',
        old: this.formatDate(data.start_time?.old_value),
        new: this.formatDate(data.start_time?.new_value),
        show: true
      },
      {
        field: 'End time',
        old: this.formatDate(data.end_time?.old_value),
        new: this.formatDate(data.end_time?.new_value),
        show: true
      },
      {
        field: 'Target person',
        old: data.email?.old_value,
        new: data.email?.new_value,
        show: true
      },
      {
        field: 'Bonus on open account',
        old: this.showText(data.is_enable_account?.old_value),
        new: this.showText(data.is_enable_account?.new_value),
        show: true
      },
      {
        field: 'Bonus amount (Yen)',
        old: data.data_open_account_jpy_bonus?.old_value,
        new: data.data_open_account_jpy_bonus?.new_value,
        show: bonus.is_enable_account
      },
      {
        field: 'Bonus amount (USD)',
        old: data.data_open_account_usd_bonus?.old_value,
        new: data.data_open_account_usd_bonus?.new_value,
        show: bonus.is_enable_account
      },
      {
        field: 'Bonus On Deposit',
        old: this.showText(data.is_enable_deposit?.old_value),
        new: this.showText(data.is_enable_deposit?.new_value),
        show: true
      },
      {
        field: 'Condition 1',
        old: data.data_deposit_conditions_0_threshold?.old_value,
        new: data.data_deposit_conditions_0_threshold?.new_value,
        show: bonus.is_enable_deposit
      },
      {
        field: 'Condition 1 bonus percent',
        old: ((data.data_deposit_conditions_0_rate?.old_value) && (data.data_deposit_conditions_0_rate?.old_value) * 100)?.toFixed(0),
        new: ((data.data_deposit_conditions_0_rate?.new_value) && (data.data_deposit_conditions_0_rate?.new_value) * 100)?.toFixed(0),
        show: bonus.is_enable_deposit
      },
      {
        field: 'Condition 2',
        old: data.data_deposit_conditions_1_threshold?.old_value,
        new: data.data_deposit_conditions_1_threshold?.new_value,
        show: bonus.is_enable_deposit
      },
      {
        field: 'Condition 2 bonus percent',
        old: ((data.data_deposit_conditions_1_rate?.old_value) && (data.data_deposit_conditions_1_rate?.old_value) * 100)?.toFixed(0),
        new: ((data.data_deposit_conditions_1_rate?.new_value) && (data.data_deposit_conditions_1_rate?.new_value) * 100)?.toFixed(0),
        show: bonus.is_enable_deposit
      },
      {
        field: 'Condition 3',
        old: data.data_deposit_conditions_2_threshold?.old_value,
        new: data.data_deposit_conditions_2_threshold?.new_value,
        show: bonus.is_enable_deposit
      },
      {
        field: 'Condition 3 bonus percent',
        old: ((data.data_deposit_conditions_2_rate?.old_value) && (data.data_deposit_conditions_2_rate?.old_value) * 100)?.toFixed(0),
        new: ((data.data_deposit_conditions_2_rate?.new_value) && (data.data_deposit_conditions_2_rate?.new_value) * 100)?.toFixed(0),
        show: bonus.is_enable_deposit
      },
      {
        field: 'Condition 4',
        old: data.data_deposit_conditions_3_threshold?.old_value,
        new: data.data_deposit_conditions_3_threshold?.new_value,
        show: bonus.is_enable_deposit
      },
      {
        field: 'Condition 4 bonus percent',
        old: ((data.data_deposit_conditions_3_rate?.old_value) && (data.data_deposit_conditions_3_rate?.old_value) * 100)?.toFixed(0),
        new: ((data.data_deposit_conditions_3_rate?.new_value) && (data.data_deposit_conditions_3_rate?.new_value) * 100)?.toFixed(0),
        show: bonus.is_enable_deposit
      },
      {
        field: 'Upper limit',
        old: data.data_deposit_up_limit?.old_value,
        new: data.data_deposit_up_limit?.new_value,
        show: bonus.is_enable_deposit && +data.data_deposit_up_limit?.old_value != +data.data_deposit_up_limit?.new_value
      },
      {
        field: 'Multiple time',
        old: this.multipleTextConverter(data.data_deposit_multiple_time?.old_value),
        new: this.multipleTextConverter(data.data_deposit_multiple_time?.new_value),
        show: bonus.is_enable_deposit
      },
      {
        field: 'Bonus timeout',
        old: data.data_deposit_dfw?.old_value,
        new: data.data_deposit_dfw?.new_value,
        show: bonus.is_enable_deposit && +data.data_deposit_dfw?.new_value != +data.data_deposit_dfw?.old_value
      },
      {
        field: 'Bonus type',
        old: this.textBonusType(data.data_bonus_type?.old_value),
        new: this.textBonusType(data.data_bonus_type?.new_value),
        show: bonus.is_enable_deposit
      },
    ];
    this.result = this.result.filter((f) => (f.old !== undefined && f.new !== undefined) || (f.old == undefined && f.new));
    const filterByDeposit = this.result.find(it => it.field === 'Bonus On Deposit' && it.new === 'Off');
    if(filterByDeposit) {
      this.result = this.result.filter((f) => !f.field.includes('Condition'));
    }
    this.withTargetPersonChanged = this.result.find((l: any) => l.field === 'Target person');
  }

  formatDate(date) {
    return date ? moment(date).format('DD/MM/YYYY  hh:mm') : undefined;
  }

  multipleTextConverter(value): string | undefined {
    if (value == 1 || value === true) {
      return 'Multiple';
    } else if (value == 0 || value === false) {
      return 'Single';
    } else {
      return undefined;
    }
  }

  showText(value): string | undefined {
    if (value == 1 || value === true) {
      return 'On';
    } else if (value == 0 || value === false) {
      return 'Off';
    } else {
      undefined;
    }
  }

  textBonusType(item): string {
    let type = '';
    switch (item) {
      case 0:
        type = 'Normal';
        break;
      case 1:
        type = 'Before';
        break;
      case 2:
        type = 'After';
        break;
      default:
        type = undefined;
        break;
    }
    return type;
  }

  cancel() {
    this.refDialog.close(false);
  }

  save() {
    const spread = [
      this.sendMailOptions.sendToNewTargetAll.checked && this.withTargetPersonChanged ? this.sendMailOptions.sendToNewTargetAll.value : '',
      this.sendMailOptions.tasks[0].checked ? this.sendMailOptions.tasks[0].value : '',
      this.sendMailOptions.tasks[1].checked ? this.sendMailOptions.tasks[1].value : '',
    ].filter(e => e.length);
    const send_email_to = this.sendOrNot ? spread : [];
    this.refDialog.close({
      send_email_to,
      email_change_promotion_content: this.email_change_promotion_content,
      email_old_target_promotion_content: this.email_old_target_promotion_content,
      email_new_target_promotion_content: this.email_new_target_promotion_content,
    });
  }


  setAllChecked() {
    if (this.sendMailOptions.tasks == null) {
      return false;
    }
    return this.sendMailOptions.tasks.filter(t => t.checked).length > 0 && !this.isSendAll;
  }

  setAll(checked: boolean) {
    this.isSendAll = checked;
    if (this.sendMailOptions.tasks == null) {
      return;
    }
    this.sendMailOptions.tasks.forEach(t => t.checked = checked);
  }

  updateAllComplete() {
    this.isSendAll = this.sendMailOptions.tasks != null && this.sendMailOptions.tasks.every(t => t.checked);
  }

  openPreviewEmailTemplateWithDataChanged() {
    this.bonusService.getPreviewMailTemplate({
      ...this.bonusService.previewMailData,
      email_type: this.withTargetPersonChanged ? 'old-target' : 'change-only'
    }).pipe(
      switchMap(({ data: { subject, html } }: PreviewEmailRequestProps) => {
        const targetAll = this.sendMailOptions.tasks[0];
        const targetApplied = this.sendMailOptions.tasks[1];
        let tmpHtml = '';
        let tmpSubject = '';
        if (this.withTargetPersonChanged) {
          if (!this.tmp_email_old_target_promotion_content) {
            this.tmp_email_old_target_promotion_content = {
              html, subject
            };
          }
          tmpHtml = this.tmp_email_old_target_promotion_content.html ? this.tmp_email_old_target_promotion_content.html : html;
          tmpSubject = this.tmp_email_old_target_promotion_content.subject ? this.tmp_email_old_target_promotion_content.subject : subject;
        } else {
          if (!this.tmp_email_change_promotion_content) {
            this.tmp_email_change_promotion_content = {
              html, subject
            };
          }
          tmpHtml = this.tmp_email_change_promotion_content.html ? this.tmp_email_change_promotion_content.html : html;
          tmpSubject = this.tmp_email_change_promotion_content.subject ? this.tmp_email_change_promotion_content.subject : subject;
        }
        return this.dialog.open(PreviewMailTemplateComponent, {
          panelClass: 'preview-mail-template-by-popup',
          data: {
            defaultData: {
              content: html,
              subject,
            },
            content: tmpHtml,
            subject: tmpSubject,
            target: `${this.preTargetUserEmail} and users under this user`,
          } as PreviewBonusMailTemplateProps
        }).afterClosed();
      })).subscribe(({ template }) => {
      if (template) {
        const { content: html, subject } = template;
        if (this.withTargetPersonChanged) {
          this.tmp_email_old_target_promotion_content = {
            html, subject
          };
          this.email_old_target_promotion_content = {
            html, subject
          };
        } else {
          this.tmp_email_change_promotion_content = {
            html, subject
          };
          this.email_change_promotion_content = {
            html, subject
          };
        }
      }

    });

    /*this.dialog.open(PreviewMailTemplateComponent, {
      panelClass: 'preview-mail-template-by-popup',
      data: {
        content: template,
        subject: `Conclusion of Our Campaign ${this.configDialog.data.campaignName} - Thank You for Your Participation!`,
        target: targetAll.checked && !targetApplied.checked  ? targetAll.label : targetApplied.checked && !targetAll.checked ? targetApplied.label : targetAll.checked && targetApplied.checked ? targetAll.label + ' and ' + targetApplied.label : 'No One'
      } as PreviewBonusMailTemplateProps
    }).afterClosed().subscribe((data) => {
      console.log(data);
    })*/
  }

  openPreviewEmailTemplateWithTargetChanged() {
    this.bonusService.getPreviewMailTemplate({
      ...this.bonusService.previewMailData,
      email_type: 'new-target'
    }).pipe(
      switchMap(({ data: { subject, html } }: PreviewEmailRequestProps) => {
        if (!this.tmp_email_new_target_promotion_content) {
          this.tmp_email_new_target_promotion_content = {
            subject, html
          };
        }
        return this.dialog.open(PreviewMailTemplateComponent, {
          panelClass: 'preview-mail-template-by-popup',
          data: {
            content: this.tmp_email_new_target_promotion_content.html ? this.tmp_email_new_target_promotion_content.html : html,
            subject: this.tmp_email_new_target_promotion_content.subject ? this.tmp_email_new_target_promotion_content.subject : subject,
            target: `${this.configDialog.data.targetUserEmail || 'Target user'} and users under this user`,
            defaultData: {
              content: html,
              subject
            }
          } as PreviewBonusMailTemplateProps
        }).afterClosed();
      })
    ).subscribe(({ template }) => {
      if (template) {
        this.tmp_email_new_target_promotion_content = {
          html: template.content,
          subject: template.subject
        };
        this.email_new_target_promotion_content = {
          html: template.content,
          subject: template.subject
        };
      }
    })
  }
}
